



















import { namespace } from 'vuex-class';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Popover } from 'element-ui';

@Component({
  components: {
    [Popover.name]: Popover
  }
})

/**
 * 项目卡片弹窗详情
 */
export default class AcgnPopCard extends Vue {
  public name: string = 'AcgnPopCard';

  @Prop({ default: {} }) public data: object; // 显示数据 {title: 'xxx', width: 13, info: 'bbb', items:[{name,value}]}
}
